import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { HealthSystemSetup } from 'src/app/core/model/v2/practice/HealthSystemSetup';
import { CommonService } from 'src/app/core/services/v2/common.service';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { SetupService } from 'src/app/physician/setup/setup.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { Case } from '../models/casehistory';
import { uniqBy } from 'lodash';
import { UserService } from 'src/app/core/services/v2/user.service';
import { CodeTable } from 'src/app/core/model/v2/code-table';
import { Patient } from 'src/app/core/models/patient/patient';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { CaseManagementService } from 'src/app/core/services/v2/case-management.service';
import { HealthSystem } from 'src/app/core/model/v2/healthSystem/health-system';
import { SidebarPhysicianEditComponent } from 'src/app/physician/profile/physician/sidebar-physician-edit/sidebar-physician-edit.component';
import { AddPatientDialogComponent } from './add-patient-dialog/add-patient-dialog.component';

@Component({
  selector: 'save-case',
  templateUrl: './save-case.component.html',
  styleUrls: ['./save-case.component.scss']
})
export class SaveCaseComponent implements OnInit {
  @Input() caseModel: Case;
  @Output() toggleEvent = new EventEmitter();
  caseManagememtPractices: HealthSystem[];
  legalPractices: HealthSystemSetup[];
caseStatus:CodeTable={} as CodeTable;
caseType:CodeTable ={} as CodeTable;
patients:Patient[]=[];
patientSearchKeyword = 'firstName';
maxDate: Date = new Date();

// @ViewChild(SidebarPhysicianEditComponent, { static: false })
//   childComponent: SidebarPhysicianEditComponent;
//caseModel:Case=new Case();
  constructor(private practiceService: PracticeService,
    private router: Router,
    private userService: UserService,
    private loaderService: WindowLoaderService,
    public authService: AuthService,
    private commonService: CommonService,
    private patientService:PatientService,
    private caseManagementService: CaseManagementService,
    public patientdialog: MatDialog,
    private _snackBar: MatSnackBar) { }

  ngOnInit() {
    
    if (this.authService.isLoggedIn()) {
      this.loadCasemanagementPractice();
      this.loadCasePractices();
    }
    this.commonService.GetItemsByCodeNamesWithoutCache(['CASESTATUS','CASETYPE']).subscribe(
      codeTables => { 
        this.caseStatus = codeTables.codeTable[0];
        this.caseType=codeTables.codeTable[1];
       },
      error => console.log(error)
    );
  }
  loadCasemanagementPractice(): void {
    //this.loadHealthOrganizatioData();

    this.loaderService.show();
    this.practiceService.getHealthOrganizationDetailsByLoggedUser().subscribe(
      (data) => {
        //this.healthOrganizationSetup = data;
        this.legalPractices = data.healthSystems.filter(x=>x.practiceType=2);
        // if (this.caseManagememtPractices && this.caseManagememtPractices.length > 0) {
        //   this.dataLength = this.healthSystems.length;
        // } else {
        //   this.dataLength = 0;
        // }
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }
  
  loadCasePractices(){
    this.practiceService.getAllHealthSystemAndPractitionersByUserID(this.caseModel.authorUserId).subscribe(
      (p) => { 
        let temphealthSystems  = p.physician.filter(h=>h.userId==this.caseModel.authorUserId); 
        console.log(temphealthSystems[0].healthSystems);
        this.caseManagememtPractices=temphealthSystems[0].healthSystems.filter(x=>x.practiceType==1);
      },
      (error) => { console.error(error); }
    );
  }
  selectEvent(item) {
    // do something with selected item
    this.caseModel.patientId=item.id;
    this.caseModel.patientName=item.firstName+" "+item.lastName;
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    
      this.patientService.getPatientDetailsByName(val).subscribe(
        (patients) => { this.patients = patients;
        console.log(patients); },
        (error) => { console.error(error); }
      );
  }
  
  onFocused(e){
    // do something when input is focused
  }
  onSave(caseModel: Case){
this.loaderService.show();
this.caseManagementService.saveCase(caseModel).subscribe(
  (res) => {
    

    this.loaderService.hide();
    this.toggleEvent.emit(this.caseModel);
  },
  (error) => {
    console.error(error);
    this.loaderService.hide();
  },
  () => {
    this.loaderService.hide();
  }
);
  }
  closeSidebar(){
    this.toggleEvent.emit(null);

  }
  openDialog() {
    this.patientdialog.open(AddPatientDialogComponent, {
      data: {
        animal: 'panda'
      }
    });
  }
 
}
